/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';
// import PropTypes from 'prop-types';
import shortid from 'shortid';
// components
import { Grid, Button, Checkbox } from '@design-system-coopeuch/web';
import CardBase from '../../atoms/CardBase/CardBase';
import CaseInfo from '../../molecules/CaseInfo/CaseInfo';
import GeneralMessage from '../../molecules/GeneralMessage/GeneralMessage';

// utils
import { isMobile } from '../../../utils/platform';
// assets
import { WrapperCheckboxs } from '../../../assets/styles/styles';
// constants
const isMobileDevice = isMobile();

const BecauseMember = (props) => {
  const {
    state,
    question,
    optionsSelected,
    disabled,
    onSelectOption,
    // onChangeComment,
    onSendResponses,
    onRetrySendResponses,
  } = props;

  return state === 'sent-becauseMember' ? (
    <GeneralMessage size="medium" type="success" alignIcon="right" iconVisibility bgOpacity>
      <p className="p-0 text-size-18 text-color-black-80">
        <strong className="text-color-success">¿Te interesa alguno de estos productos? - </strong>
        ¡Bien! Ya te conocemos un poco más
      </p>
    </GeneralMessage>
  ) : (
    <CardBase title={question.question} noPadding shadedOutline intereactionDisabled={disabled}>
      {state === 'error-becauseMember' ? (
        <Grid className="py-5">
          <CaseInfo
            caseInfo="errorSurveyBecauseMember"
            isMobile={isMobileDevice}
            onClickButton={onRetrySendResponses}
          />
        </Grid>
      ) : (
        <>
          <Grid className="py-4 px-md-6 border-bottom border-neutral-alfa-15">
            {state === 'initial' && (
              <>
                <p className="mt-1 mb-2 mt-md-2 mb-md-3 line-height-20">
                  Esto es una
                  <strong> encuesta opcional </strong>
                  que nos ayudará a guiarte en tus preferencias una vez seas Socio Coopeuch
                </p>
                <WrapperCheckboxs>
                  <section className="grid-order-by-columns">
                    {question.alternatives.map((el) => (
                      <Fragment key={shortid.generate()}>
                        <Checkbox
                          id={shortid.generate()}
                          label={el.description}
                          checked={optionsSelected.some((ele) => ele.idOption === el.idOption)}
                          onChange={(ev) => onSelectOption({ idOption: el.idOption, selected: ev })}
                        />
                      </Fragment>
                    ))}
                  </section>
                </WrapperCheckboxs>
              </>
            )}
            {state === 'loading' && (
              <></>
              // TODO: pendiente dessarrolo para loading
            )}
          </Grid>
          <Grid
            row
            className="p-4 px-md-6 py-3 d-flex justify-content-center align-items-center justify-content-md-end"
          >
            <Grid className="p-0 d-flex justify-content-center justify-content-md-end">
              <Button
                className="w-100 max-width-md-200 d-flex justify-content-center"
                disabled={optionsSelected.length === 0}
                onClick={() => onSendResponses()}
                color="secondary"
              >
                Enviar mi respuesta
              </Button>
            </Grid>
          </Grid>
        </>
      )}
    </CardBase>
  );
};

export default BecauseMember;
